/* eslint-disable react/require-default-props */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { AiManagementState } from 'store/modules/ai_management_store/types';
import { memberColor } from 'services/ai_management_member_colors';
import { Avatar } from './styles';

interface AiManagementAvatarProps {
  initials: string;
  memberId?: number;
  name?: string;
  size?: number;
  bordered?: boolean;
  balloonPosition?: 'up' | 'up-left' | 'up-right' | 'down' | 'down-left' | 'down-right';
  className?: string;
}

const AiManagementAvatar: React.FC<AiManagementAvatarProps> = ({
  initials,
  memberId,
  name,
  size = 28,
  bordered = false,
  balloonPosition = 'up',
  className = '',
}) => {
  const team = useSelector<ApplicationState, AiManagementState['team']>(
    (state) => state.session.ai_management.team,
  );

  const tone = useMemo(
    () =>
      memberId === undefined
        ? undefined
        : memberColor(
            memberId,
            team.map((member) => member.id),
          ),
    [memberId, team],
  );

  return (
    <Avatar
      size={size}
      bordered={bordered}
      tone={tone}
      role={name ? 'img' : undefined}
      aria-label={name}
      data-balloon-pos={name ? balloonPosition : undefined}
      data-balloon-blunt={name ? true : undefined}
      className={`d-inline-flex align-items-center justify-content-center flex-shrink-0 ${
        name ? 'databalloon' : ''
      } ${className}`}
    >
      {initials}
    </Avatar>
  );
};

export default AiManagementAvatar;
